module.exports = __webpack_public_path__ + "img/tyre_fuel_icon_1.93edbdba.png";